import { Component, OnInit, inject } from '@angular/core';
import {BlogService} from '../../service/blog.service';
import {ActivatedRoute} from '@angular/router';
import {SafeHtml} from '@angular/platform-browser';
import {DynamicHooksComponent} from 'ngx-dynamic-hooks';

/**
 * Renders a detail view for the blog item
 *
 * @author evandongen
 */
@Component({
	selector: 'blog-detail',
	template: ` @if (blogHtml) {
		<ngx-dynamic-hooks
				[options]="{ sanitize: false }"
				[content]="blogHtml.toString()">
		</ngx-dynamic-hooks>
	}`,
	standalone: true,
	imports: [DynamicHooksComponent],
})
export class BlogDetailComponent implements OnInit {
	private blogService = inject(BlogService);
	private route = inject(ActivatedRoute);

	blogId: string | null;
	blogHtml: SafeHtml | null = null;

	ngOnInit() {
		this.blogId = this.route.snapshot.paramMap.get('blogId');

		if (this.blogId !== null) {
			this.blogService
				.getBlogDetail(this.blogId)
				.then(result => (this.blogHtml = result));
		}
	}
}
